/* ------------------------------------------------------------------
   OVERLAY MENU, 2026-10-24 (pm).

   The overlay is back to the look it has on the live theme, so this file is
   back to driving the live mechanism: #mobileMenuOverlay.open, the hamburger
   painted into a white X by body.menu-is-open, the full-screen photograph
   under the header. What it does NOT bring back are the three faults the
   owner reported, all reproduced at 390x844 on live before this was written.

   1. Closing left the page dead. body.menu-is-open sets opacity: 0 and
      pointer-events: none on .header__icons, and the old script removed that
      class on the hamburger path only. Closing with the scrim, or by
      following a link, left Search, Account and Cart invisible and unusable
      on the page behind. Every close path here runs one teardown.

   2. There was no way out on a phone. #closeMobileMenu is display: none below
      990px in the theme's own CSS, so the X in the corner is the hamburger
      itself. It is inside .header-wrapper, which body.menu-is-open lifts to
      z-index 10002, one above the overlay, and the listener below is capturing
      so nothing else can swallow the tap.

   3. An open panel printed through the foot. That one is in mdc-nav.css; the
      part that belongs here is .is-tall, set whenever the menu is taller than
      the screen so the rows get a real gap instead of packing edge to edge,
      and the small scroll that keeps a freshly opened panel in view.

   Tapping MEN expands and never navigates: the row is a <button>, and the
   menu's own first child (ALL MEN) is the way into the collection.
------------------------------------------------------------------ */
(function () {
  'use strict';

  var overlay = document.getElementById('mobileMenuOverlay');
  if (!overlay || !overlay.classList.contains('mobile-menu-overlay')) return;

  var menu = overlay.querySelector('.mdc-mmenu');
  var hamburger = document.querySelector('.header__icon--menu');
  var lastFocus = null;

  function isOpen() {
    return overlay.classList.contains('open');
  }

  /* the rows pack edge to edge once space-evenly has no free space left to
     spread, so say out loud when that has happened */
  function measure() {
    if (!menu) return;
    var tall = menu.scrollHeight > overlay.clientHeight + 1;
    overlay.classList.toggle('is-tall', tall);
  }

  function open() {
    lastFocus = document.activeElement;
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    // the X, the transparent header bar and the hidden announcement strip all
    // hang off this class in mdc-editorial.css
    document.body.classList.add('menu-is-open');
    document.body.style.overflow = 'hidden';
    measure();
    if (menu) menu.focus({ preventScroll: true });
  }

  function close() {
    overlay.classList.remove('open');
    overlay.classList.remove('is-tall');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-is-open');
    // theme.liquid's observer clears this one too; cleared here as well so the
    // header can never be left transparent over a closed menu
    document.body.classList.remove('mdc-menu-open');
    document.body.style.overflow = '';
    collapseAll();
    overlay.scrollTop = 0;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  function toggleMenu() {
    if (isOpen()) close(); else open();
  }

  /* ---- expanding ---- */

  function itemOf(btn) {
    return btn.closest('li');
  }

  function collapse(btn) {
    var li = itemOf(btn);
    if (!li) return;
    btn.setAttribute('aria-expanded', 'false');
    li.classList.remove('is-open');
    // a nested panel closes with its parent, or it reopens invisibly next time
    Array.prototype.forEach.call(li.querySelectorAll('[aria-expanded="true"]'), function (inner) {
      inner.setAttribute('aria-expanded', 'false');
      var innerLi = itemOf(inner);
      if (innerLi) innerLi.classList.remove('is-open');
    });
  }

  function expand(btn) {
    var li = itemOf(btn);
    if (!li) return;
    btn.setAttribute('aria-expanded', 'true');
    li.classList.add('is-open');
  }

  function collapseAll() {
    Array.prototype.forEach.call(overlay.querySelectorAll('[aria-expanded="true"]'), function (b) {
      b.setAttribute('aria-expanded', 'false');
      var li = itemOf(b);
      if (li) li.classList.remove('is-open');
    });
  }

  /* after an expand, bring the panel into view without yanking the row that
     was tapped off the top of the screen */
  function reveal(btn) {
    var li = itemOf(btn);
    if (!li) return;
    var row = btn.getBoundingClientRect();
    var box = li.getBoundingClientRect();
    var bottom = overlay.clientHeight;
    var over = box.bottom - bottom;
    if (over <= 0) return;
    // never scroll so far that the row itself leaves the top of the screen
    var headroom = Math.max(0, row.top - 8);
    overlay.scrollTop += Math.min(over + 8, headroom);
  }

  overlay.addEventListener('click', function (e) {
    var btn = e.target.closest('.mdc-mmenu__toggle, .mdc-mmenu__subtoggle');
    if (btn && overlay.contains(btn)) {
      e.preventDefault();
      var wasOpen = btn.getAttribute('aria-expanded') === 'true';
      var siblingSelector = btn.classList.contains('mdc-mmenu__toggle')
        ? '.mdc-mmenu__toggle[aria-expanded="true"]'
        : '.mdc-mmenu__subtoggle[aria-expanded="true"]';
      // one panel open per level keeps the list short enough to read
      Array.prototype.forEach.call(overlay.querySelectorAll(siblingSelector), function (other) {
        if (other !== btn) collapse(other);
      });
      if (wasOpen) collapse(btn); else expand(btn);
      measure();
      if (!wasOpen) reveal(btn);
      return;
    }

    // a real link closes the menu so the next page never loads behind it
    var link = e.target.closest('a[href]');
    if (link && overlay.contains(link)) { close(); return; }

    // the ground beside the list
    if (e.target === overlay || e.target === menu) close();
  });

  if (hamburger) {
    hamburger.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggleMenu();
      },
      true
    );
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  window.addEventListener('resize', function () { if (isOpen()) measure(); }, { passive: true });
})();
